var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-page"},[_c('div',{staticClass:"page-header"},[_vm._t("page-header",function(){return [_c('div',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.titleLabel))]),_vm._t("title-left")]},{"titleLabel":_vm.titleLabel})],2),_c('div',{staticClass:"page-content",style:({width: _vm.width})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }